import { DataBean } from "../DataBean";

export class FiscalResponsabilityType extends DataBean {


    public async getFiscalResponsabilityTypeCatalog(idFiscalResponsabilityType: number | null): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getFiscalResponsabilityTypeCatalog_Number", [idFiscalResponsabilityType]);
    }
}